import React, { useState, useEffect } from 'react';
import NavBar from './components/NavBar';
import TabBar from './components/TabBar';
import { checkExistingAuth } from './components/Authentication';
import Login from './components/Login';
import MainContent from './components/MainContent';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [selectedTab, setSelectedTab] = useState('Dashboard');
  const [initializing, setInitializing] = useState(true);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    checkExistingAuth(setUser, setInitializing);

    const handleCustomTabChange = (e) => {
      setSelectedTab(e.detail);
    };
    window.addEventListener('changeTab', handleCustomTabChange);
    return () => {
      window.removeEventListener('changeTab', handleCustomTabChange);
    };
  }, []);

  if (initializing) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', color: 'white' }}>
        <h2>Loading Intelligent Palm Analytics...</h2>
      </div>
    );
  }

  return (
    <div className="App">
      {user ? (
        <div>
          <NavBar>
            <TabBar
              selectedTab={selectedTab}
              onTabChange={handleTabChange}
            />
          </NavBar>
          <MainContent selectedTab={selectedTab} />
          <ToastContainer position="top-right" autoClose={10000} />
        </div>
      ) : (
        <Login setUser={setUser} />
      )}
    </div>
  );
}

export default App;
